import { IconDeviceGamepad2 } from '@tabler/icons-react';
import parse from 'html-react-parser';
import { useTranslation } from 'react-i18next';

import { Button } from '@cfa/react-core';

import { extractTridionGameInformation } from '@/utils/document-utils';

import { useScaledGamePreview } from './useScaledGamePreview';

import { useGameFullscreen } from '@/atoms/document';

interface TridionGameContentProps {
  htmlContent: string | undefined;
}

const TridionGameContent: React.FC<TridionGameContentProps> = ({
  htmlContent,
}) => {
  const { t } = useTranslation();
  const gameInformation = extractTridionGameInformation(htmlContent);

  const [, setIsGameFullscreen] = useGameFullscreen();

  const initialContentSize =
    gameInformation?.width && gameInformation.height
      ? { width: gameInformation.width, height: gameInformation.height }
      : undefined;

  const { containerRef, iframeRef, contentSize, scale, onIframeLoad } =
    useScaledGamePreview({
      initialContentSize,
      tridionHtmlContent: htmlContent,
      url: gameInformation?.url,
    });

  return (
    <div className="flex flex-col gap-5 pt-10">
      <div
        ref={containerRef}
        className="shadow-elevation-8 relative aspect-video w-full overflow-hidden rounded-lg"
        data-testid="GamePreviewFrame"
      >
        {gameInformation?.url && contentSize ? (
          <div
            className="pointer-events-none absolute top-1/2 left-1/2"
            style={{
              width: contentSize.width,
              height: contentSize.height,
              transform: `translate(-50%, -50%) scale(${scale})`,
            }}
          >
            <iframe
              key={gameInformation.url}
              ref={iframeRef}
              allow="fullscreen"
              className="game-preview-iframe size-full border-0"
              onLoad={onIframeLoad}
              scrolling="no"
              src={gameInformation.url}
              title="Game"
            />
          </div>
        ) : null}
      </div>
      {gameInformation?.descriptionHtml ? (
        <div className="mt-0!" data-testid="GameDescription">
          {parse(gameInformation.descriptionHtml)}
        </div>
      ) : null}
      <Button
        className="w-min px-13!"
        color="secondary"
        onPress={() => {
          if (gameInformation?.url) {
            setIsGameFullscreen(true);
          }
        }}
        data-testid="GamePlayNowButton"
      >
        <IconDeviceGamepad2 />
        {t('games.playNow')}
      </Button>
    </div>
  );
};

export default TridionGameContent;
